import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router'
import { React, useEffect, useState } from 'react'

import './App.css'
import './MApp.css'


import Cookies from 'universal-cookie'

import Home from './pages/Home/Home'
import Page404 from './pages/Page404/Page404'


import { generateUUID, getBrowser } from './main.js'

import Kontakt from './pages/Kontakt/Kontakt.js'
import Services from './pages/Services/Services.js'
import About from './pages/About/About.js'
import Referenzen from './pages/Referenzen/Referenzen.js'
import Aktuelles from './pages/Aktuelles/Aktuelles.js'
import AktuellesDetail from './pages/AktuellesDetail/AktuellesDetail.js'
import Impressum from './pages/Impressum/Impressum.js'
import Datenschutz from './pages/Datenschutz/Datenschutz.js'
import LP_Channext_Apple from './pages/Landingpages/LP_Channext_Apple/LP_Channext_Apple.js'
import Barrierefreiheit from './pages/Barrierefreiheit/Barrierefreiheit.js'

const cookies = new Cookies()

export default function App() {
    useEffect(() => {
        try {
            // window.screen.orientation.lock("portrait")
        } catch (e) {
            console.log(e)
        }
    }, [])

    let cur_userid = cookies.get('userid')
    let loggedin = (cur_userid != "" && cur_userid != undefined)

    var agentinfo = getBrowser(navigator.userAgent)
    var location = window.location

    // console.log(agentinfo.browser)
    // console.log(agentinfo.agent)
    // console.log(location.pathname)

    return (
        <Router>
            {/* basename={'/'} */}
            <Routes>

                <Route path="/about" element={<About />} />
                <Route path="/kontakt" element={<Kontakt />} />
                <Route path="/services" element={<Services />} />
                <Route path="/referenzen" element={<Referenzen />} />

                <Route path="/impressum" element={<Impressum />} />
                <Route path="/datenschutz" element={<Datenschutz />} />
                <Route path="/barrierefreiheit" element={<Barrierefreiheit />} />

                <Route path="/aktuelles/:newsidurl" element={<AktuellesDetail />} />
                <Route path="/aktuelles" exact={true} element={<Aktuelles />} />
                <Route path="/jobs*" element={<Navigate to={"/aktuelles"} from={"/"} />} />

                <Route path="/lp/apple_1" element={<LP_Channext_Apple />} />
                <Route path="/lp/*" element={<Page404 />} />

                {/* Alte URLs */}
                <Route path="/aktuelle-infos*" element={<Navigate to={"/aktuelles"} from={"/"} />} />
                <Route path="/team*" element={<Navigate to={"/about"} from={"/"} />} />
                <Route path="/leistungen/*" element={<Navigate to={"/services"} from={"/"} />} />
                <Route path="/referenzen/de/" element={<Navigate to={"/referenzen"} from={"/"} />} />
                <Route path="/partner/de/" element={<Navigate to={"/referenzen"} from={"/"} />} />
                <Route path="/kontakt-anfahrt/*" element={<Navigate to={"/kontakt"} from={"/"} />} />

                <Route path="/" element={<Home />} exact />
                <Route path="/*" element={<Page404 />} />
                <Route element={<Page404 />} />
            </Routes>
        </Router>
    )
}

